<template>
    <div>
    <b-breadcrumb :items="items" style="background-color: transparent"></b-breadcrumb>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    text: 'Home',
                    to: { name: 'categories' }
                },
                {
                    text: 'Modulos',
                    to: { name: 'modulos' }
                },
                {
                    text: 'Rim Normal',
                    to: { name: 'rim-normal' }
                },
                {
                    
                }
            ],
        }
    }
}
</script>

<style>
a {
  color: #2c3e50;
}
</style>